import { useDispatch, useSelector } from "src/redux/hooks";
import { setCaseReportModalData } from "src/redux/slices/generatorFeaturesSlice";

import EntriesModal from "../EntriesModal/EntriesModal";

const CaseReportModal = () => {
  const { caseReportModalData } = useSelector(
    state => state.generatorFeaturesSlice,
  );

  const handleClose = () => {
    dispatch(setCaseReportModalData(null));
  };
  const dispatch = useDispatch();

  return (
    <EntriesModal
      data={caseReportModalData?.data}
      title={`Entries with ${caseReportModalData?.caseNumber ?? ""}`}
      onClose={handleClose}
      isNormalEntries={true}
    />
  );
};
export default CaseReportModal;
